import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App'
import LoginPage from './pages/auth/LoginPage'
import { useAuthStore } from './stores/auth'
import { WebSocketProvider } from './components/realtime/WebSocketProvider'
import LicenseGuard from './components/license/LicenseGuard'
import './index.css'
import './styles/components.css'

void Promise.resolve(useAuthStore.persist.rehydrate()).then(() => {
  void useAuthStore.getState().bootstrapSession();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 3,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <WebSocketProvider>
          {/* License gate: when the backend reports enforced && not activated,
              this renders the ActivationScreen instead of login/app. */}
          <LicenseGuard>
            <Routes>
              {/* Standalone pages (no sidebar) */}
              <Route path="/login" element={<LoginPage />} />
              {/* All other routes go through App (sidebar + glass shell) */}
              <Route path="/*" element={<App />} />
            </Routes>
          </LicenseGuard>
        </WebSocketProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
